import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, ConfigProvider, Flex, Form, Input, message, notification, Radio, Row, Select, Space } from "antd";
import React, { useEffect, useState } from "react";
import type { FlexProps, FormProps, RadioChangeEvent, SegmentedProps, TableProps } from 'antd';
import flex from "antd/es/flex";
import TextArea from "antd/es/input/TextArea";
import { draftInterface } from "../models/IDraft";
import axios from "axios";
import { oecdInterface } from "../models/Ioecd";
import { Navigate, useNavigate } from "react-router-dom";
import { SizeType } from "antd/es/config-provider/SizeContext";
import { ResearchHistory } from "../models/IResearchHistory";
import { Regex } from "lucide-react";
import moment from "moment";

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i+543);

const handleChange = (value: string) => {
    console.log(`selected ${value}`);
  };
  const options = [
    { label: 'Apple', value: 'Apple' },
    { label: 'Pear', value: 'Pear' },
    { label: 'Orange', value: 'Orange', title: 'Orange' },
  ];

export function BudgetReqDraft(){
    const [oecd,setOECD] = useState<oecdInterface[]>([])
    const [DraftForm] = Form.useForm();
    const [nameEn,setNameEn] = useState('')
    const [nameTh,setNameTh] = useState('')

    const TypeCheck = Form.useWatch('project_type',DraftForm)

    const [success,setSuccess] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [loading,setLoading] = React.useState(false);
    const [TimesSent,setTimesSent] = useState(0)
    const [YearsSent, setYearsSent] = useState(
      (parseInt(moment().format('YYYY')) + 543).toString()
    );
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const [selectedoecdtype,setselectedOECDtype] = useState("");
    const [selectedoecdsub,setselectedoecdsub] = useState("");
    const [selectedField,setselectedField] = useState(0);
    const [BudgetType,setBudgetType] = useState('');
    const [destination,setDestination]=useState(``)

    const [subOptions, setSubOptions] = useState<ItemProps[]>([]);
    const [fieldOptions, setFieldOptions] = useState<ItemProps[]>([]);
    const [showfield,setShowField] = useState(false)

    

    interface ItemProps {
      label: string;
      value: string;
    }
    
  
  
const handleThChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
  const newValue = e.target.value;
  const regex = /^[\u0E50-\u0E59\s!@#$%^&*()_+={}:;"'<>,.?\/`~\-’]*$/;

  // Update state if the new value matches the regex
  if (regex.test(newValue) || newValue === '') {
    setNameTh(newValue);
  }
};

  const handleOECDTypeChange = (e: RadioChangeEvent) => {
    const value = e.target.value;
    setselectedOECDtype(value);
    setselectedoecdsub("");
    setFieldOptions([]);

    const selectedType = oecd.find(item => item.oecd_type === value);
    if (selectedType) {
        const subOptions = selectedType.subdata.map(sub => ({
            label: sub.oecd_sub_type,
            value: sub.oecd_sub_type,
        }));
        setSubOptions(subOptions);
    }
};
    
const handleOECDSubChange = (e: RadioChangeEvent) => {
  const value = e.target.value;
  setselectedoecdsub(value);
  console.log(value)
  const selectedType = oecd.find(item => item.oecd_type === selectedoecdtype);
  console.log(selectedType)
  if (selectedType) {
    
      const selectedSub = selectedType.subdata.find(sub => sub.oecd_sub_type === value);
      console.log(selectedSub)
      console.log(selectedSub?.Info)
      if (selectedSub && selectedSub.Info) {
        console.log(selectedSub.Info[0].oecd_field)
        if(!selectedSub.Info[0].oecd_field){
          setShowField(false);
          setselectedField((selectedSub.Info[0].oecd_id))
        }else{
          const Field = selectedSub.Info.map(field => ({
            label: field.oecd_field,
            value: String(field.oecd_id),
        }));
        console.log(Field)
        setFieldOptions(Field);
        setShowField(true);
        }
      } else {
          setFieldOptions([]); // Reset field options if `selectedSub` or `info` is undefined
          setShowField(false);
      }
  } else {
      setFieldOptions([]); // Reset field options if `selectedType` is undefined
      setShowField(false);
  }
};


    
  
    const getOECD = async()=>{
        axios.get(`${process.env.REACT_APP_BASE}/oecd`).then(response => {
            console.log(response.data)
            setOECD(response.data)
        }).catch(error =>{console.log(error)})
    }
    
    const navigate = useNavigate();
    const handletoFront = () =>{
      setLoading(true);
      // if(success){
      //   messageApi.open({
      //     type: 'success',
      //     content: 'บันทึกสำเร็จ',
      //   });
      //   navigate(`/`)
      // }else{
      //   messageApi.open({
      //     type: 'error',
      //     content: `บันทึกไม่สำเร็จ : ${errorMessage}`,
      //   });
      // }
      setDestination(`/VRIIS`)
        
  }
  
     const handleFinish : FormProps<draftInterface>['onFinish'] = (values) => {
        console.log(values)
        console.log(Number(sessionStorage.getItem("user")))
        console.log('กำลังกดบันทึก')
        const data = {
            project_name_th: values.project_name_th,
            project_name_en: values.project_name_en,
            head_researcher: Number(sessionStorage.getItem("user")),
            budget_type:BudgetType,
            oecd_id : selectedField,
            project_type : values.project_type,
            project_status : 'แก้ไข',
            Fac_ID : sessionStorage.getItem('Fac_ID'),
            TimesSent:TimesSent,
            YearsSent:YearsSent,
            otherProjectType:values.other_project_type
          }
          console.log(data)
          
        // return data
        axios.post(`${process.env.REACT_APP_BASE}/BudgetDraft`, data)
        .then((response) => {
          if (response.status === 200) {
            console.log("บันทึกสำเร็จ")
            setSuccess(true);
            console.log(response);
            setSuccess(true);
            navigate(destination);
          }
        })
        .catch((error) => {
            setLoading(false);
            setError(true);
            console.log(error)
            console.log(error.response)
            notification.error({
                message: "บันทึกข้อมูลไม่สำเร็จ",
                description: error.response.data.Message,
              });
            setErrorMessage(error.response.data.Message)
        });
    }
    

      

      const handleSelect = (value: string) => {
        console.log(`selected ${value}`);
        setselectedOECDtype(value)
      };
      
      
      

    useEffect(()=>{
        getOECD();
    },[]);
    return(
      <ConfigProvider
      theme={{
          components: {
          Select: {
              optionSelectedColor: '#8174A0',
              optionActiveBg: "#E5E1DA",
              controlItemBgActive: '#FFD2A0'
          },
          },
      }}
      >

  <Form 
      wrapperCol={{ span: 20 }}
      layout="vertical"
      form={DraftForm}
      onFinish={handleFinish}
      autoComplete="off"
      size={componentSize as SizeType}
      style={{
        padding:15
      }}>
      <h1 className="text-3xl font-semibold ">แบบฟอร์มเสนอโครงการงานวิจัยและนวัตกรรม</h1>  
      <p>เพื่อขอรับเงินทุนสนับสนุนงานวิจัยและนวัตกรรมจากมหาวิทยาลัยวงษ์ชวลิตกุล</p>
          <br/>
          <hr/>
          <br/>
      <h2 className="text-2xl font-bold ">แบบร่างข้อมูลโครงการวิจัย</h2>
          <br/>
          <Form.Item<draftInterface> className='font-semibold' style={{ maxWidth: 800 }} name={['project_name_th']} label='ชื่อโครงการที่ท่านต้องการยื่นเสนอ'
            rules={[
              { required: true, 
            message: 'ชื่อโครงการวิจัยของท่านไม่สามารถปล่อยว่างได้',
            }]}>
            
          <TextArea 
          className='font-normal'
          style={{marginLeft: '40px'}}
          onChange={handleThChange}
          placeholder="ชื่อโครงการภาษาไทย" autoSize />
          </Form.Item>

          <Form.Item<draftInterface> style={{ maxWidth: 800 }} name={['project_name_en']} 
            rules={[{ required: true, 
            message: 'ชื่อโครงการวิจัยของท่านไม่สามารถปล่อยว่างได้'},
            {
            pattern: /^[a-zA-Z0-9\s!@#$%^&*()_+={}:;"'<>,.?\/`~\-’]*$/ ,
            message: 'ชื่อโครงการของท่านที่กรอกในช่องนี้ ต้องเป็นตัวอักษรภาษาอังกฤษ ตัวเลข และสัญลักษณ์เท่านั้น'
            }]}>
          <TextArea style={{marginLeft: '40px'}}
          placeholder="ชื่อโครงการภาษาอังกฤษ" autoSize />
          </Form.Item>

          
          <Form.Item<draftInterface> className='font-semibold' style={{ maxWidth: 800 }} name={['head_researcher']} label='ชื่อหัวหน้าโครงการวิจัย/อาจารย์ที่ปรึกษาโครงการวิจัย' layout="vertical">
          <Input className='font-normal' style={{marginLeft: '40px'}} placeholder={String(sessionStorage.getItem("fullname"))} value={15} disabled />
          </Form.Item>

          <Form.Item label='ครั้งที่ยื่นขอทุน' className='font-semibold' layout="vertical">
          <p style={{ marginLeft: '40px', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
            ครั้งที่&nbsp;
            <Select
            value={TimesSent}
            onChange={(value)=>setTimesSent(value)}
            style={{width:'10vw'}}
              options={[
                { label: '1', value: 1 },
                { label: '2', value: 2 },
                { label: '3', value: 3 },
                { label: '4', value: 4 },
                { label: '5', value: 5 },
              ]}
            />
            /<Select
              value={YearsSent}
              onChange={(value)=>setYearsSent(value)}
              style={{ width: 120 }}
              options={years.map((year) => ({
                label: year.toString(),
                value: year.toString(),
              }))}
            />
          </p>
          </Form.Item>

          <Form.Item label='ประเภททุน' className='font-semibold' layout="vertical">
              <Radio.Group className='font-normal' value={BudgetType} onChange={e => setBudgetType(e.target.value)}>
                <Radio value="ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา">ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา</Radio>
                <Radio value="ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร">ทุนวิจัยและนวัตกรรมสำหรับอาจารย์และบุคลากร</Radio>
              </Radio.Group>
          </Form.Item>

          
            <Form.Item<draftInterface> className='font-semibold' style={{ maxWidth: 800 }} name={['project_type']} label='ประเภทโครงการวิจัย' layout="vertical">
              <Select
              className='font-normal'
              defaultValue={'กรุณาเลือกประเภทของงานวิจัย'}
              style={{ width: 500 ,marginLeft: '40px'}}
              onChange={handleChange}
              options={[
                  { value: 1, label: 'งานวิจัยเชิงวัฒนธรรม' },
                  { value: 2, label: 'งานนวัตกรรม' },
                  { value: 3, label: 'งานวิจัยเพื่อสร้างองค์ประกอบความรู้พื้นฐาน' },
                  { value: 4, label: 'งานวิจัยเชิงประยุกต์' },
                  { value: 5, label: 'งานสร้างสรรค์(หนังสั้น สารคดี โฆษณา)' },
                  { value: 6, label: 'งานวิจัยประเมินหลักสูตร' },
                  { value: 7, label: 'อื่นๆ' },
              ]}
              />
          </Form.Item>

         {TypeCheck==7&&
         <Form.Item<draftInterface> style={{marginLeft:'40px',maxWidth: 800 }} className='font-semibold' name={['other_project_type']} label='โปรดระบุ' layout='horizontal'>
            <Input/>
          </Form.Item>}

          <Form.Item className='font-semibold' label='โปรดเลือกสาขาวิชาที่ทำการวิจัยจำแนกตามOECD'>
                    <Space direction="vertical">
                    <Radio.Group className='font-normal' onChange={handleOECDTypeChange} value={selectedoecdtype}>
                    <Space direction="vertical">
                      {oecd.map((item) => (
                        <React.Fragment key={item.oecd_type}>
                        <Space direction="vertical">
                        <Radio value={item.oecd_type}>{item.oecd_type}</Radio>
                        {selectedoecdtype === item.oecd_type && (
                          <Radio.Group style={{ marginLeft: '20px' }} onChange={handleOECDSubChange} value={selectedoecdsub}>
                          <Space direction="vertical" style={{ marginLeft: '20px' }}>
                              {subOptions.map((subitem) => (
                                <><Radio value={subitem.value} key={subitem.value}>
                                  {subitem.label}
                                </Radio>
                                {showfield && (<>
                                {
                                  selectedoecdsub === subitem.label && (
                                    <Form.Item>
                                    <Radio.Group onChange={(e) => setselectedField(e.target.value)} value={selectedField} style={{ marginLeft: '40px' }}> 
                                    <Space direction="vertical">
                                    {fieldOptions.map((field) => (
                                        <Radio key={field.value} value={field.value}>
                                        {field.label}
                                      </Radio>
                                    ))}
                                    </Space>
                                    </Radio.Group>
                                    </Form.Item>
                                  )
                                }
                                    </>
                                )}
                                
                                </>
                                  
                              ))}
                              </Space>
                            </Radio.Group>)}
                          </Space>
                          
                          </React.Fragment>
                          ))}
                          
                            </Space>
                        </Radio.Group>
                    </Space>
                </Form.Item>
                <hr style={{ borderTop: '1px solid #8c8b8b' }} />
          <br/>
          <Flex justify='space-between'><Button type="primary" ><a href={"/VRIIS"}> กลับ </a></Button> 
          <Button type="primary" loading={loading} style={{backgroundColor:'#33b249',color:'white',borderColor:'#33b249'}} htmlType='submit' onClick={handletoFront}>บันทึกฉบับร่าง </Button></Flex>
  </Form>
  </ConfigProvider> 
        
    )
}